<template>
    <section class="stallions-page">
        <h1 id="stallions" class="print-title">Stallions with their Progeny</h1>
        <p class="text-center">
            Foals arranged under their sires, alphabetically within each year, born {{ yearsRange }}
        </p>
        <p class="text-center">
            <i>(Including some late registrations omitted from previous volumes)</i>
        </p>
        <p class="text-center">
            (The symbol § indicates the sire is a stallion domiciled abroad at the time of breeding)
        </p>
    </section>

    <div class="break-after"></div>

    <div>
        <div class="single-stallion" v-for="stallion in stallions" :key="stallion.regNr">
            <div class="stallion-name">
                <span class="horse-name">{{ stallion.horseName }}</span> {{ stallion.regNr }}
            </div>
            <div class="stallion-details">
                <span v-html="formatStallionDetailsHtml(stallion)"></span>
                {{ stallion.importYear ? `Imported in ${stallion.importYear} from ${stallion.importCountry}. ` : "" }}
                {{ stallion.studbook ? `See ${stallion.studbook}.` : "" }}
            </div>
            <table class="stallion-foals-table">
                <tbody>
                    <tr v-for="(foal, index) in stallion.foals" :key="foal.regNr">
                        <td>{{ computedYear(foal, index, stallion.foals) }}</td>
                        <td>{{ foal.dateOfBirth }}</td>
                        <td>{{ foal.color }}.{{ foal.sex }}</td>
                        <td><b><span class="horse-name">{{ foal.name }}</span></b> {{ foal.regNr }}</td>
                        <td>out of <span class="horse-name">{{ foal.damName }}</span> {{ foal.damRegNr }}</td>
                        <td>{{ foal.owner }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {yearFromToMixin} from "@/views/readonly/studbook/util/yearFromToMixin";

export default {
    name: "StallionsPage",
    mixins: [yearFromToMixin],
    props: {
        stallions: Array,
    },
    methods: {
        computedYear(rowData, rowIndex, records) {
            if (rowIndex === 0) return rowData.yearOfBirth;

            const previousRow = records[rowIndex - 1];
            return previousRow.yearOfBirth !== rowData.yearOfBirth ? rowData.yearOfBirth : "";
        },
        formatStallionDetailsHtml(s) {
            const details = this.formatStallionDetails(s);
            return details.length > 0 ? `${details}. ` : "";
        },
        formatStallionDetails(s) {
            const parts = [];
            const firstSection = [];
            const secondSection = [];
            const thirdSection = [];

            if (s.color) firstSection.push(s.color);
            if (s.yearOfBirth) firstSection.push(s.yearOfBirth);
            if (s.strain) firstSection.push(s.strain);

            if (s.breeder) secondSection.push(s.breeder);

            if (s.sireName) {
                let sireInfo = `By <span class="horse-name">${s.sireName}</span>`;
                if (s.sireSireName || s.sireDamName) {
                    const sireSireName = s.sireSireName ? `<span class="horse-name">${s.sireSireName}</span>` : "";
                    const sireDamName = s.sireDamName ? `/<span class="horse-name">${s.sireDamName}</span>` : "";
                    sireInfo += ` (${sireSireName}${sireDamName})`;
                }
                thirdSection.push(sireInfo);
            }

            if (s.damName) {
                let damInfo = `out of <span class="horse-name">${s.damName}</span>`;
                if (s.damSireName || s.damDamName) {
                    const damSireName = s.damSireName ? `<span class="horse-name">${s.damSireName}</span>` : "";
                    const damDamName = s.damDamName ? `/<span class="horse-name">${s.damDamName}</span>` : "";
                    damInfo += ` (${damSireName}${damDamName})`;
                }
                thirdSection.push(damInfo);
            }

            parts.push(firstSection.join(", "));
            parts.push(secondSection);
            parts.push(thirdSection.join(", "));

            const partsToReturn = parts.filter((el) => {
                if (Array.isArray(el) && el.length === 0) return false;
                return !(typeof el === "string" && el === "");
            });

            return partsToReturn.join(". ");
        },
    },
};
</script>

<style lang="scss" scoped>
.stallions-page {
    margin-top: 50% !important;
}
</style>
